export enum TableColumnTypeEnum {
  SINGLE_BUTTON = 'singleButton',
  GROUP_BUTTONS = 'groupButtons',
  CUSTOM = 'custom',
  OBJECT = 'object',
  STRING = 'string',
  VALIDATION = 'validation',
  CHECKBOX = 'checkbox'
}

export enum TablePipesTypeEnum {
  ACTIVE = 'active',
  BIOEXAMS_STATUS = 'bioexamsStatusPipe',
  CNPJ = 'cnpj',
  CPF = 'cpf',
  CURRENCY = 'currency',
  DATE = 'date',
  DATE_AND_TIME = 'dateAndTime',
  DATE_TO_FRONT = 'dateToFront',
  DATABASE_OPTIONS = 'databaseOptions',
  FORMAT_NAME = 'formatName',
  FINANCIAL_PEOPLE_ADDRESS = 'financialPeopleAddressPipe',
  FINANCIAL_PEOPLE_SITUATION_PIPE = 'financialPeopleSituationPipe',
  FINANCIAL_RELEASE_GROUPE_TYPE_PIPE = 'financialReleaseGroupTypePipe',
  FINANCIAL_OCCURRENCE_TYPE = 'financialOccurrenceTypePipe',
  PHONE = 'phone',
  REMOVE_UNDERSCORE = 'removeUnderscore',
  SITUATION_REGISTRATION = 'situationRegistration',
  SITUATION = 'situationPipe',
  TIME_TO_FRONT = 'timeToFront',
  TYPE_DOCUMENT = 'typedocument',
  TYPE_GROUP = 'typeGroup',
  TYPE_PEOPLE = 'typePeoplePipe',
  TYPE_RELEASE = 'typeReleasePipe',
  TYPE_OF_PRACTICAL_SCHEDULING_PIPES = 'typeOfPracticalSchedulingPipe',
  TYPE_PRODUCT = 'typeProduct',
  TRUE_FALSE = 'truefalse',

}

export enum TableButtonsEnum {
  ICON = 'icon',
  MINI_FAB = 'mini',
  RAISED = 'raised',
  STROKED = 'stroked',
}
